/**
 * Los datos de formulario del Explorador (clientes, catálogo de campos, líneas de control y
 * cuentas con su moneda), del mismo endpoint que `DataExplorerHeader` y `fieldsCatalog`.
 *
 * `fieldsCatalog.loadFieldsCatalog` descarta todo menos `fields_data`; la pantalla de Informes
 * necesita también `ad_accounts` y `business_units` para el selector de Ajustes. Singleton en
 * memoria, igual que el catálogo.
 */
import {APIClient} from './APIClient';
import {API_URL} from '../settings/local_settings';

let cache = null;
let inflight = null;

export function loadExplorerFormData() {
    if (cache) return Promise.resolve(cache);
    if (inflight) return inflight;
    inflight = new APIClient(API_URL + 'node-to-gsheet/sync-configuration/form-data')
        .call('GET')
        .then((data) => {
            cache = data && data.fields_data ? {
                agencyClients: data.agency_clients || [],
                fieldsData: data.fields_data,
                businessUnits: data.business_units || [],
                adAccounts: data.ad_accounts || [],
            } : null;
            inflight = null;
            return cache;
        })
        .catch(() => {
            inflight = null;
            return null;
        });
    return inflight;
}

export function clearExplorerFormDataCache() {
    cache = null;
    inflight = null;
}
